export const LOGIN_USER = 'login_user';
export const REGISTER_USER = 'register_user';
export const AUTH_USER = 'auth_user';
export const LOGOUT_USER = 'logout_user';
export const GET_GROUP_CHATS = 'get_group_chat';
export const GET_CHATS = 'get_chat';
export const AFTER_POST_MESSAGE = 'after_post_message';
